import styled from 'styled-components';
import { Colors } from './../../aquaplot/colors';

export const CodeContainer = styled.div`
    max-height: 400px;
    overflow: auto;
    background-color: ${Colors.aqp_deep_sea};
    color: whitesmoke;
`